var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.1595,
    height: 3.87472,
    rx: 1.93736,
    transform: "matrix(0.70568 0.70853 -0.70568 0.70853 2.77002 0.0357819)",
    fill: "#12124A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1595,
    height: 3.87472,
    rx: 1.93736,
    transform: "matrix(-0.70568 0.70853 -0.70568 -0.70853 14.8433 2.74535)",
    fill: "#12124A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCross);
export default __webpack_public_path__ + "static/media/calendar-cross.0e777535c203b325bcc00b590a854e40.svg";
export { ForwardRef as ReactComponent };